var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.SubscribeComponent,{tag:"component",attrs:{"form-id":_vm.formId,"message":_vm.message,"email":_vm.email,"source":'footer'},on:{"changeStep":_vm.changeStep}})}
var staticRenderFns = []

export { render, staticRenderFns }